let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iMgwi")).then(() => parcelRequire('3Ewna'));